import React, {ReactNode} from "react";
import Row from "@Containers/components/Row";
import ColoredRatingStar from "@Features/ratings/components/ColoredRatingStar";

interface StopInfoFragmentProps {
    label: string,
    icon?: ReactNode,
    children?: ReactNode,
    rating?: number
}

const StopInfoFragment = ({label, icon, children, rating = null}: StopInfoFragmentProps) => {
    return (
        <div className="stop-information-field">
            <Row center>
                {icon}
                <span className="stop-information-field-label">{label}</span>
                {rating && rating > 0 && (
                    <ColoredRatingStar score={rating}/>
                )}
            </Row>
            {children}
        </div>
    );
}

export default StopInfoFragment;